(function () {
  class Logo extends PIXI.Container {
    constructor() {
      super();

      this._logoAnim = undefined;
      this._logo = undefined;

      this.spinOnRepeat = false;
      this.isPlaying = false;
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._logoAnim = resourceManager.get('gameLogo:logoAnim');
      this._logoPortraitAnim = resourceManager.get('gameLogo:logoPortraitAnim');
      this._logoAnim.gotoAndStop(0);
      this._logoPortraitAnim.gotoAndStop(0);

      const self = this;
      this._logoAnim.onComplete = function () {
        self._logoAnim.gotoAndStop(0);
        self._logoPortraitAnim.gotoAndStop(0);
        self.isPlaying = false;
        if (self.playOnRepeat) {
          gsap.delayedCall(1, self.playAnimationOnRepeat.bind(self));
          self.playOnRepeat = true;
        }
      };
    }

    playAnimationOnRepeat() {
      this.playAnimation();
      this.playOnRepeat = true;
    }

    stopRepeatAnimation() {
      this.playOnRepeat = false;
    }

    playAnimation() {
      this.playOnRepeat = false;
      this.isPlaying = true;

      this._logoAnim.gotoAndPlay(0);
      this._logoPortraitAnim.gotoAndPlay(0);
    }
  }

  let create = function (json) {
    return new Logo();
  };

  let initialise = function (json, logo) {
    logo.initialise();
  };

  let getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('logo', create, initialise, getFilesRequired);
})();
